document.addEventListener('click',e=>{const b=e.target.closest('.nav-toggle');if(!b)return;const n=document.querySelector('.main-nav');n.classList.toggle('open');b.setAttribute('aria-expanded',n.classList.contains('open'))});

/* Interactive product gallery */
function changeProductImage(thumbnail) {
  const gallery = thumbnail.closest('.product-gallery');
  const mainImage = gallery.querySelector(
    '.product-gallery__item:first-child img'
  );
  const thumbnailImage = thumbnail.querySelector('img');

  if (!mainImage || !thumbnailImage) return;

  mainImage.src = thumbnailImage.currentSrc || thumbnailImage.src;
  mainImage.srcset = thumbnailImage.srcset || '';
  mainImage.alt = thumbnailImage.alt || '';

  gallery
    .querySelectorAll('.product-gallery__item')
    .forEach((item) => item.classList.remove('is-selected'));

  thumbnail.classList.add('is-selected');
}

document.addEventListener('click', function (event) {
  const thumbnail = event.target.closest(
    '.product-gallery__item:not(:first-child)'
  );

  if (thumbnail) {
    changeProductImage(thumbnail);
  }
});

document.addEventListener('keydown', function (event) {
  const thumbnail = event.target.closest(
    '.product-gallery__item:not(:first-child)'
  );

  if (
    thumbnail &&
    (event.key === 'Enter' || event.key === ' ')
  ) {
    event.preventDefault();
    changeProductImage(thumbnail);
  }
});

document
  .querySelectorAll('.product-gallery__item:not(:first-child)')
  .forEach((thumbnail) => {
    thumbnail.setAttribute('role', 'button');
    thumbnail.setAttribute('tabindex', '0');
    thumbnail.setAttribute('aria-label', 'Preview product image');
  });
